<!-- Navbar -->
<app-navbar></app-navbar>

<!-- <div class="flex flex-col md:flex-row h-screen"> -->
<!-- Aside (Barra lateral) -->
<app-aside></app-aside>

<!-- Main (Contenido principal) -->
<!-- <main class="flex-1 p-4 overflow-y-auto"> -->
<app-main></app-main>
<!-- </main> -->
<!-- </div> -->

<!-- Footer -->
<app-footer></app-footer>
